import { createEmptyStoreSection, generateStoreSectionId } from '@/config/storeHomepageSections'

/**
 * Normalize legacy flat homepage sections into builder page document shape
 * (matches blu-storefront builder fixtures until props nesting is universal).
 */
export function buildPageDocument ({
  pageType = 'home',
  sections = [],
  metadata = {},
  schemaVersion = 1,
} = {}) {
  return {
    schemaVersion,
    pageType,
    metadata: {
      title: metadata.title ?? '',
      description: metadata.description ?? '',
    },
    sections: normalizeSectionsForDocument(sections),
  }
}

export function buildHomePageDocument (opts = {}) {
  return buildPageDocument({ ...opts, pageType: 'home' })
}

export function buildProductTemplateDocument (opts = {}) {
  return buildPageDocument({ ...opts, pageType: 'product_template' })
}

export function ensureProductDetailsSection (sections) {
  const list = Array.isArray(sections) ? [...sections] : []
  const has = list.some(s => s?.type === 'product_details')
  if (!has) {
    list.push(createProductDetailsSection())
  }
  return list
}

export function createProductDetailsSection () {
  return createEmptyStoreSection('product_details')
}

export function normalizeSectionsForDocument (sections) {
  if (!Array.isArray(sections)) return []
  return sections.map(normalizeSectionForDocument)
}

export function normalizeSectionForDocument (section) {
  if (!section || typeof section !== 'object') {
    return { id: generateStoreSectionId('hero'), type: 'hero', version: 1, title: '', subtitle: '' }
  }
  const type = section.type || 'hero'
  const base = {
    ...section,
    id: section.id || generateStoreSectionId(type),
    type,
    version: section.version ?? 1,
  }
  delete base.props
  return base
}

export function documentSectionsToLegacy (document) {
  const sections = document?.sections
  if (!Array.isArray(sections)) return []
  return sections.map((s) => normalizeSectionForDocument(s))
}

export function cloneBuilderState (state) {
  return JSON.parse(JSON.stringify(state))
}
